/**
 * UnchangedProviderCard
 *
 * Compact display for a known provider with no detected changes.
 * No review actions needed.
 */
import { Badge } from '../../ui/badge';
import { Card, CardContent } from '../../ui/card';
import type { UnchangedProviderItem } from './types';

interface UnchangedProviderCardProps {
  item: UnchangedProviderItem;
}

export const UnchangedProviderCard = ({ item }: UnchangedProviderCardProps) => {
  return (
    <Card className="bg-muted/30">
      <CardContent className="flex items-center justify-between p-4">
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium">{item.provider_name}</span>
          <Badge variant="outline" className="text-[10px]">
            Unchanged
          </Badge>
        </div>
        <div className="flex items-center gap-3 text-xs text-muted-foreground">
          <span>{item.current_status}</span>
          {item.current_frequency && (
            <>
              <span>&middot;</span>
              <span>{item.current_frequency}</span>
            </>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
